import EVM from '../classes/evm.class';
import Opcode from '../interfaces/opcode.interface';

export default (opcode: Opcode, state: EVM): void => {
    state.stack.pop();
};
